import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation AchievementDelete($uid: String!){
        achievement_delete (uid: $uid) {
            success
        }
    }
`;

export async function achievementDelete(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ achievement_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.achievement_delete;
}
